module.exports = __webpack_public_path__ + "static/steveTargus-b80fcccaa741b7f167970cfd0219b57f.jpeg";